// Generated by scripts/optimize-images.ts — do not edit by hand.
// Public-directory sources that have committed .avif/.webp siblings.
export const PUBLIC_OPTIMIZED_SOURCES: ReadonlySet<string> = new Set([
  "/coachella-festival.png",
  "/festival-friends.png",
  "/mmw-festival.png",
  "/troopn-logo-transparent.png",
  "/troopn-logo.png",
  "/ultra-festival.png",
]);
